import { connect } from 'react-redux'
import { IStore } from '../../../reducers'
import { getEnabledFilters } from '../../../reducers/bookingCalendar/selectors/filtering'
import { IFilterDrawerState } from './FilterDrawer'

function mapStateToProps() {
  const filters = getEnabledFilters

  return function(state: IStore): IFilterDrawerState {
    return {
      activeFilters: filters(state),
    }
  }
}

export default connect(mapStateToProps())
